export default "__VITE_ASSET__F$oK3zz7__"